/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (boostSDAppConfig?.generalSettings?.collection_handle && ['gallery', 'clearance-gems'].includes(boostSDAppConfig.generalSettings.collection_handle)) {
  document.body.classList.add('hide-prices')
}